import { render } from "./RadioButton.vue?vue&type=template&id=713059ae&scoped=true"
import script from "./RadioButton.vue?vue&type=script&lang=js"
export * from "./RadioButton.vue?vue&type=script&lang=js"

import "./RadioButton.vue?vue&type=style&index=0&id=713059ae&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713059ae"]])

export default __exports__